module.exports = __webpack_public_path__ + "img/registration.238333f3.jpg";